"use strict"// Import loglevel
import log from 'loglevel';
window.log = log;

// Import Just Validate
import JustValidate from 'just-validate';
// Import SweetAlert2
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss'
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
console.log('Bootstrap loaded', bootstrap);
// Import Swiper JS
// import Swiper bundle with all modules installed
/*import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';*/
// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
// Import typeahead standalone
import typeahead from 'typeahead-standalone';
// Import Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

/*// Import scrollcue.js
import scrollcue from scrollcue;
window.scrollCue = scrollcue;*/

// Process SCSS
import '../scss/simvim.scss';

window.SIMVIM = {};
SIMVIM.el = {};
SIMVIM.config = {};
SIMVIM.swipers = {};
SIMVIM.forms = {};
	
SIMVIM.config.portrait = window.matchMedia("(orientation: portrait)");
SIMVIM.config.name = "SIMVIM";
SIMVIM.config.version = "0.8.0";
SIMVIM.config.colors = {}
SIMVIM.config.colors.main = "#da1b23";

document.addEventListener("DOMContentLoaded", function() {
	log.warn(`%c${SIMVIM.config.name} DOM ready.`, `color:${SIMVIM.config.colors.main}`);

	SIMVIM.el.body = document.getElementsByTagName("body")[0];

	// Init scrollcue.js
    scrollCue.init();

	// Slider for events
	/*const eventsSwiperEls = document.querySelectorAll(".swiper-events .swiper");
	eventsSwiperEls.forEach(eventsSwiperEl => {*/
	const eventsSwiperEl = document.querySelector(".swiper-events");
	if (eventsSwiperEl) {
		const eventSlides = eventsSwiperEl.querySelectorAll('.swiper-slide');
		if (eventSlides.length > 0) {
			new Swiper(eventsSwiperEl, {
				modules: [Pagination, Autoplay],
				slidesPerView: 1,
				spaceBetween: 0,
				loop: eventSlides.length > 1,
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				},
				pagination: {
					el: eventsSwiperEl.parentElement.querySelector('.swiper-events-pagination'),
					clickable: true,
				},
				observer: true,
				observeParents: true,
				watchSlidesProgress: true,
			});
		}
	}
	//});

	// Slider for news
	const newsSwiperEl = document.querySelector(".swiper-news");
	if (newsSwiperEl) {
		new Swiper(newsSwiperEl, {
			modules: [Navigation],
			slidesPerView: 3,
			spaceBetween: 25,
			loop: true,
			navigation: {
				nextEl: newsSwiperEl.parentElement.querySelector('.swiper-button-next'),
				prevEl: newsSwiperEl.parentElement.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				0: { slidesPerView: 1 },
				768: { slidesPerView: 2 },
				992: { slidesPerView: 3 }
			}
		});
	}

	// Slider for news hero (news-events page)
	const newsHeroSwiperEl = document.querySelector(".swiper-news-hero");
	if (newsHeroSwiperEl) {
		new Swiper(newsHeroSwiperEl, {
			modules: [Navigation, Pagination, Autoplay],
			slidesPerView: 2,
			spaceBetween: 25,
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			navigation: {
				nextEl: newsHeroSwiperEl.parentElement.querySelector('.swiper-button-next'),
				prevEl: newsHeroSwiperEl.parentElement.querySelector('.swiper-button-prev'),
			},
			pagination: {
				el: newsHeroSwiperEl.parentElement.parentElement.querySelector('.swiper-pagination'),
				clickable: true,
			},
			breakpoints: {
				0: { slidesPerView: 1 },
				768: { slidesPerView: 2 }
			}
		});
	}


	// Slider for banners
	const bannerSwiperEl = document.querySelector(".swiper-banners");
	if (SIMVIM.el.body.classList.contains('page--home') && bannerSwiperEl) {
		new Swiper(bannerSwiperEl, {
			modules: [Navigation, Autoplay],
			slidesPerView: 2,
			spaceBetween: 25,
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: bannerSwiperEl.parentElement.querySelector('.swiper-button-next'),
				prevEl: bannerSwiperEl.parentElement.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				0: { slidesPerView: 1 },
				768: { slidesPerView: 2 }
			}
		});
	}

	// input element to attach to
	const inputElement = document.getElementById("search_nation");
	if (inputElement) {
		let firstSuggestion = null;
		const searchButton = inputElement.parentElement.querySelector('button[type="submit"]');

		// Swiper for search nation
		SIMVIM.swipers.searchNation = document.getElementsByClassName("swiper-searchNation")[0];
		if (SIMVIM.swipers.searchNation) {
			// Learn-slider
			var swiper = new Swiper(SIMVIM.swipers.searchNation, {
				modules: [/*Navigation, */EffectFade, Autoplay],
      			effect: "fade",
				loop: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				}/*,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},*/
			});
		}

		window.typeahead = typeahead({
			input: inputElement,
			source: {
				prefetch: {
					url: location.origin + '/nazioni.json',
					when: 'onInit',          // optional, default => 'onInit'
					done: false,              // optional, default => false
					//process: (items) => void, // optional, default => undefined
					//requestOptions: {}        // optional, default => undefined
				},
				keys: ["title"],
				minLength: 1, // default - 1
				limit: 5, // default - 5
			},
			hooks: {
				updateHits: (resultSet) => {
					firstSuggestion = resultSet.hits.length > 0 ? resultSet.hits[0] : null;
					return resultSet;
				}
			},
			classNames: {
				wrapper: 'typeahead-standalone'
			},
			hint: true,
			autoSelect: true, // default - false
			highlight: true, // default - true
			diacritics: true,				
			display: (item, event) => {
				if (event) {
					// do something
					console.log("event type is - " + event.type);
					
					switch (event.type) {
						case 'click':
							location.href = item.url;
							break;
					}
				}
			return `${item.title}`;
			},
			templates: {
				//header: (resultSet) => '<h5>Dove vuoi viaggare?</h5>',      /* Rendered at the top of the list */
				//footer: (resultSet) => '<a href="nazioni">Scopri di più</a>',  /* Rendered at the bottom of the list */
				suggestion: (item, resultSet) => {
					// Renders a single suggestion 
					return `<div class="suggestion-label"><span>${item.title}</span><img src="${item.cover}"></div>`;
				},
				group: (groupName, resultSet) => {
					return `<span class="group-label">${groupName}</span>`;
				},
				loader: () => 'Caricamento...',
				notFound: (resultSet) => '<b>Nessun risultato trovato.</b>',
				empty: (resultSet) => {
					// show default suggestions
					//return [...];

					// OR show custom html
					return `<div>Cerca la nazione dove sei diretto.</div>`;
				},
			},
			onSubmit: (e, selectedSuggestion) => {
				const query = e.target.value;
				if (selectedSuggestion) {
					location.href = selectedSuggestion.url;
				}
				//alert(`input -> ${query}, eventType -> ${e.type}`);

				/*if (selectedSuggestion) {
					alert('Selected suggestion - ' + JSON.stringify(selectedSuggestion));
				}*/
			}
		});

		if (searchButton) {
			searchButton.addEventListener('click', (e) => {
				e.preventDefault();
				if (firstSuggestion && firstSuggestion.url) {
					location.href = firstSuggestion.url;
				}
			});
		}
	}

	// FORM NEWSLETTER
	SIMVIM.forms.contacts = document.getElementById("simvim_form_contacts");
	if (SIMVIM.forms.contacts) {		
		log.info(`Contact form loaded.`);
		SIMVIM.forms.contacts.el = {};
		SIMVIM.forms.contacts.el.$fullname = SIMVIM.forms.contacts.querySelector(`[name="fullname"]`);
		SIMVIM.forms.contacts.el.$email = SIMVIM.forms.contacts.querySelector(`[name="email"]`);
		SIMVIM.forms.contacts.el.$emailControl = SIMVIM.forms.contacts.querySelector(`[name="email_control"]`);
		SIMVIM.forms.contacts.el.$message = SIMVIM.forms.contacts.querySelector(`[name="message"]`);
		SIMVIM.forms.contacts.el.$privacyPolicy = SIMVIM.forms.contacts.querySelector(`[name="privacy_policy"]`);

		const validator_form_contacts = new JustValidate(SIMVIM.forms.contacts);
		validator_form_contacts
		.addField(SIMVIM.forms.contacts.el.$fullname, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.contacts.el.$fullname.dataset.errorRequired,
			}
		])
		.addField(SIMVIM.forms.contacts.el.$email, [
			{
				rule: "required",
				errorMessage: SIMVIM.forms.contacts.el.$email.dataset.errorRequired,
			},
			{
				rule: "email",
				errorMessage: SIMVIM.forms.contacts.el.$email.dataset.errorEmail,
			},
		])
		.addField(SIMVIM.forms.contacts.el.$message, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.contacts.el.$message.dataset.errorRequired,
			},
			{
				rule: 'minLength',
				errorMessage: SIMVIM.forms.contacts.el.$message.dataset.errorMinlength,
				value: 10,
			},
			{
				rule: 'maxLength',
				errorMessage: SIMVIM.forms.contacts.el.$message.dataset.errorMaxlength,
				value: 6000,
			},
		])
		.addField(SIMVIM.forms.contacts.el.$privacyPolicy, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.contacts.el.$privacyPolicy.dataset.errorRequired,
			},
		])
		.onSuccess((event) => {
			event.preventDefault();
			console.log(event);
			let form = event.currentTarget;
			let formData = new FormData();
			formData.append("fullname", SIMVIM.forms.contacts.el.$fullname.value);
			formData.append("email", SIMVIM.forms.contacts.el.$email.value);
			formData.append("email_control", SIMVIM.forms.contacts.el.$emailControl.value);
			formData.append("message", SIMVIM.forms.contacts.el.$message.value);
			// Explicitly convert boolean to string for PHP to detect it
			const privacyChecked = SIMVIM.forms.contacts.el.$privacyPolicy.checked;
			formData.append("privacy_policy", privacyChecked ? "true" : "");
			
			formData.append("submit", 'true');
			fetch(`${window.location}.json?submit`, {
				method: "POST",
				body: formData,
			})
			.then(response => response.json())
			//.then(response => console.log(response))
			.then(result => {
				console.log(result);
				switch (result.response) {
					case "success":
						Swal.fire({
							title: `Ottimo!`,
							html: `L'email è stata inviata con successo`,
							icon: "success",
							confirmButtonColor: SIMVIM.config.colors.main
						});
						form.reset();
						validator_form_contacts.refresh()
						break;
					case "error":
						Swal.fire({
							title: `Errore`,
							text: result.errorMessage, //`Email non inviata. Si prega di riprovare.`,
							icon: "error",
							confirmButtonColor: SIMVIM.config.colors.main
						});
						break;
				}
			})
			.catch(error => log.warn(error));
		});
	}

	// FORM SUBSCRIBE
	SIMVIM.forms.subscribe = document.getElementById("simvim_form_subscribe");
	if (SIMVIM.forms.subscribe) {
		log.info(`Subscribe form loaded.`);
		SIMVIM.forms.subscribe.el = {};
		SIMVIM.forms.subscribe.el.$modeGroup = SIMVIM.forms.subscribe.querySelector(`#mode_group`);
		SIMVIM.forms.subscribe.el.$fullname = SIMVIM.forms.subscribe.querySelector(`[name="fullname"]`);
		SIMVIM.forms.subscribe.el.$birth_place = SIMVIM.forms.subscribe.querySelector(`[name="birth_place"]`);
		SIMVIM.forms.subscribe.el.$birth_date = SIMVIM.forms.subscribe.querySelector(`[name="birth_date"]`);
		SIMVIM.forms.subscribe.el.$cf = SIMVIM.forms.subscribe.querySelector(`[name="cf"]`);
		SIMVIM.forms.subscribe.el.$address = SIMVIM.forms.subscribe.querySelector(`[name="address"]`);
		SIMVIM.forms.subscribe.el.$phone = SIMVIM.forms.subscribe.querySelector(`[name="phone"]`);
		SIMVIM.forms.subscribe.el.$email = SIMVIM.forms.subscribe.querySelector(`[name="email"]`);
		SIMVIM.forms.subscribe.el.$profession = SIMVIM.forms.subscribe.querySelector(`[name="profession"]`);
		SIMVIM.forms.subscribe.el.$receipt = SIMVIM.forms.subscribe.querySelector(`[name="receipt"]`);
		SIMVIM.forms.subscribe.el.$privacyPolicy = SIMVIM.forms.subscribe.querySelector(`[name="privacy_policy"]`);

		const validator_form_subscribe = new JustValidate(SIMVIM.forms.subscribe);
		validator_form_subscribe
		.addRequiredGroup(SIMVIM.forms.subscribe.el.$modeGroup, SIMVIM.forms.subscribe.querySelector('#mode_new').dataset.errorRequired)
		.addField(SIMVIM.forms.subscribe.el.$fullname, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.subscribe.el.$fullname.dataset.errorRequired,
			}
		])
		.addField(SIMVIM.forms.subscribe.el.$birth_place, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.subscribe.el.$birth_place.dataset.errorRequired,
			}
		])
		.addField(SIMVIM.forms.subscribe.el.$birth_date, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.subscribe.el.$birth_date.dataset.errorRequired,
			}
		])
		.addField(SIMVIM.forms.subscribe.el.$cf, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.subscribe.el.$cf.dataset.errorRequired,
			}
		])
		.addField(SIMVIM.forms.subscribe.el.$address, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.subscribe.el.$address.dataset.errorRequired,
			}
		])
		.addField(SIMVIM.forms.subscribe.el.$phone, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.subscribe.el.$phone.dataset.errorRequired,
			}
		])
		.addField(SIMVIM.forms.subscribe.el.$email, [
			{
				rule: "required",
				errorMessage: SIMVIM.forms.subscribe.el.$email.dataset.errorRequired,
			},
			{
				rule: "email",
				errorMessage: SIMVIM.forms.subscribe.el.$email.dataset.errorEmail,
			},
		])
		.addField(SIMVIM.forms.subscribe.el.$profession, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.subscribe.el.$profession.dataset.errorRequired,
			}
		])
		.addField(SIMVIM.forms.subscribe.el.$receipt, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.subscribe.el.$receipt.dataset.errorRequired,
			},
			{
				rule: 'files',
				value: {
					files: {
						extensions: ['jpeg', 'jpg', 'png', 'pdf'],
						maxSize: 5000000,
						minSize: 0,
						types: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
					},
				},
				errorMessage: 'File non valido (Max 5MB, PDF/JPG/PNG)',
			},
		])
		.addField(SIMVIM.forms.subscribe.el.$privacyPolicy, [
			{
				rule: 'required',
				errorMessage: SIMVIM.forms.subscribe.el.$privacyPolicy.dataset.errorRequired,
			},
		])
		.onSuccess((event) => {
			event.preventDefault();
			let form = event.currentTarget;
			let formData = new FormData(form);
			formData.append("submit", 'true');
			
			fetch(`${window.location}.json`, {
				method: "POST",
				body: formData,
			})
			.then(response => response.json())
			.then(result => {
				switch (result.response) {
					case "success":
						Swal.fire({
							title: `Ottimo!`,
							html: `La tua richiesta è stata inviata con successo. Ti risponderemo al più presto!`,
							icon: "success",
							confirmButtonColor: SIMVIM.config.colors.main
						});
						form.reset();
						validator_form_subscribe.refresh()
						break;
					case "error":
						Swal.fire({
							title: `Errore`,
							html: result.errorMessage || `Si è verificato un errore. Riprova più tardi.`,
							icon: "error",
							confirmButtonColor: SIMVIM.config.colors.main
						});
						break;
				}
			})
			.catch(error => {
				log.warn(error);
				Swal.fire({
					title: `Errore`,
					text: `Si è verificato un errore di connessione.`,
					icon: "error",
					confirmButtonColor: SIMVIM.config.colors.main
				});
			});
		});
	}

	// Initialize Fancybox
	Fancybox.bind("[data-fancybox]", {
		// Custom options
	});

	// AJAX Pagination for News and Events Pages
	if (SIMVIM.el.body.classList.contains('page--news-events') || SIMVIM.el.body.classList.contains('page--news-list') || SIMVIM.el.body.classList.contains('page--event-list')) {
		document.addEventListener('click', function(e) {
			// Check if clicked element is a pagination link (news or events)
			const paginationLink = e.target.closest('#news-pagination a.page-link, #events-pagination a.page-link');
			if (paginationLink) {
				e.preventDefault();
				
				const url = paginationLink.getAttribute('href');
				if (!url) return;

				// Determine container and pagination IDs based on click
				const isEvents = paginationLink.closest('#events-pagination');
				const containerId = isEvents ? 'events-content-container' : 'news-content-container';
				const paginationId = isEvents ? 'events-pagination' : 'news-pagination';

				// Show loading state
				const container = document.getElementById(containerId);
				if (container) {
					container.style.opacity = '0.5';
					container.style.pointerEvents = 'none';
				}

				// Fetch new content
				fetch(url)
					.then(response => response.text())
					.then(html => {
						// Parse the HTML
						const parser = new DOMParser();
						const doc = parser.parseFromString(html, 'text/html');
						
						// Get the new content
						const newContent = doc.getElementById(containerId);
						
						if (newContent && container) {
							// Replace content
							container.innerHTML = newContent.innerHTML;
							container.style.opacity = '1';
							container.style.pointerEvents = 'auto';
							
							// Update URL without page reload
							window.history.pushState({}, '', url);
							
							// Scroll to top of section
							container.scrollIntoView({ behavior: 'smooth', block: 'start' });
							
							// Reinitialize news swiper if it exists on the new page (only for news/events mixed page)
							const newSwiperEl = container.querySelector('.swiper__news-hero');
							if (newSwiperEl) {
								new Swiper(newSwiperEl, {
									modules: [Navigation, Pagination, Autoplay],
									slidesPerView: 2,
									spaceBetween: 25,
									loop: true,
									autoplay: {
										delay: 5000,
										disableOnInteraction: false,
										pauseOnMouseEnter: true,
									},
									navigation: {
										nextEl: newSwiperEl.parentElement.querySelector('.swiper-button-next'),
										prevEl: newSwiperEl.parentElement.querySelector('.swiper-button-prev'),
									},
									pagination: {
										el: newSwiperEl.parentElement.parentElement.querySelector('.swiper-pagination'),
										clickable: true,
									},
									breakpoints: {
										0: { slidesPerView: 1 },
										768: { slidesPerView: 2 }
									}
								});
							}

							// Reinitialize sidebar events swiper if it exists (for news-events page)
							const sidebarSwiperEls = container.querySelectorAll('.swiper__events');
							sidebarSwiperEls.forEach(swEl => {
								const slides = swEl.querySelectorAll('.swiper-slide');
								if (slides.length > 0) {
									new Swiper(swEl, {
										modules: [Pagination, Autoplay],
										slidesPerView: 1,
										spaceBetween: 0,
										loop: slides.length > 1,
										autoplay: {
											delay: 5000,
											disableOnInteraction: false,
											pauseOnMouseEnter: true,
										},
										pagination: {
											el: swEl.parentElement.querySelector('.swiper__events-pagination'),
											clickable: true,
										},
										observer: true,
										observeParents: true,
										watchSlidesProgress: true,
									});
								}
							});
						}
					})
					.catch(error => {
						log.warn('AJAX pagination error:', error);
						if (container) {
							container.style.opacity = '1';
							container.style.pointerEvents = 'auto';
						}
					});
			}
		});
	}
});